import React, { useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import _ from 'lodash';
import { deleteEvent, updatePlan } from 'gqlQueries/promoRecommendation';

const errorMessage: string = 'Something went wrong!';

function useSaveScenario({ onComplete }: { onComplete: Function }) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);

    const [saveScenario, { data: eventsListData, loading: eventsListDataLoading, error: eventsListDataError }] =
        useMutation(updatePlan, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            onComplete();
            //if data present parse it
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setLoading(false);
        setError(String(error));
    }

    return {
        loading,
        error,
        setError,
        saveScenario: (variables: any) => {
            setError(null);
            setLoading(true);
            saveScenario(variables);
        },
    };
}

export { useSaveScenario };
